import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
import communicationIllustration from '../../assets/images/communication-illus.svg';
import ideaIllustration from '../../assets/images/idea-illus.svg';
import { defaultEnvironment } from '../../environment';
import { useAmplitudeTracker } from '../../hooks/tracker';
import { Button } from '../button';
import { RedirectIcon } from '../icons';
import BttfPointsRules from './bttf-points-rules';
function BttfFAQ({
  showBttfSite,
  padding
}) {
  const {
    t
  } = useTranslation();
  const {
    trackEvent
  } = useAmplitudeTracker();
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    paddingX: padding ? 3 : 0,
    paddingY: padding ? 3 : 0
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingX: "32px",
    paddingY: "32px"
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 18,
      fontWeight: 800
    }
  }, t('commons.challenges.bttf_faq.title')), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.challenges.bttf_faq.description')), /*#__PURE__*/React.createElement(BttfPointsRules, null)), showBttfSite && /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    sx: {
      containerType: 'inline-size'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#cdf5e3",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    padding: 3,
    width: {
      '@': '100%',
      '@600': 'calc((100% - 24px) / 2)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: communicationIllustration,
    width: 64
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenges.bttf_faq.communication_kit_card.title')), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.challenges.bttf_faq.communication_kit_card.description'))), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    href: defaultEnvironment.bttf.communicationKitUrl,
    onClick: () => trackEvent('Communication Kit Link Clicked', {
      context: 'BTTF FAQ Tab'
    }),
    rel: "noreferrer",
    size: "small",
    target: "_blank",
    variant: "text"
  }, t('commons.challenges.bttf_faq.communication_kit_card.action')))), /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#d9e7ff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    padding: 3,
    width: {
      '@': '100%',
      '@600': 'calc((100% - 24px) / 2)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: ideaIllustration,
    width: 64
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenges.bttf_faq.know_more_card.title')), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.challenges.bttf_faq.know_more_card.description'))), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    endIcon: /*#__PURE__*/React.createElement(RedirectIcon, null),
    href: "https://geovelo-entreprise.com/biketothefuture/",
    onClick: () => trackEvent('BTTF Learn More Link Clicked'),
    rel: "noreferrer",
    size: "small",
    target: "_blank",
    variant: "text"
  }, t('commons.challenges.bttf_faq.know_more_card.action'))))));
}
export default BttfFAQ;